// extracted by mini-css-extract-plugin
export default {"scrollButton":"ScrollToTop_scrollButton__IfoTc","visible":"ScrollToTop_visible__NV1Cl"};